"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=SchoolInfo.js.map